<template>
  <q-btn
    :loading="isLoading"
    :disable="isLoading"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Data {
  isLoading: boolean
}

export default defineComponent({
  props: {
    task: Object as () => Promise<any>,
  },
  data(): Data {
    return {
      isLoading: false,
    };
  },
  watch: {
    task(task?: Promise<any>) {
      this.isLoading = false;
      if (task) {
        this.isLoading = true;
        task.finally(() => {
          this.isLoading = false;
        });
      }
    },
  },
});
</script>
